import { register } from 'async-ops';
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions, throwExceptionErrors } from '../../../../../utils/fetch';

export const GET_REVIEW_CONTRACTORS = 'GET_REVIEW_CONTRACTORS';

export const service = async (data) => {
  const response: any = await callMvcApi({
    url: '/api/EsMD/GetEsMDReviewContractors',
    type: "GET",
    contentType: 'application/json',
    ...getDefaultOptions(),
  })
  throwExceptionErrors(response);
  return response;

};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(GET_REVIEW_CONTRACTORS, service, mock);
